<template>
  <div class="main-content-container"> 
    <div class="type_member_container" v-if="$route.meta.type==='member'">
      <div class="member_menu">
        <member-menu></member-menu>
      </div>
      <div class="member_content">
        <router-view></router-view>
      </div>
    </div>
    <div class="other_container" v-else>
      <router-view ></router-view>
    </div>
    <div class="footer_container">
      <!-- <nav-footer></nav-footer> -->
      <nav-footer :homeData22="homeData2"></nav-footer>
    </div>
  </div>
</template>

<script>
// import Bus from "@/components/layout/bus"
import navFooter from '@/components/layout/navFooter'
export default {
  props:{
    homeData2:{}
  },
  data () {
    return{
      homeData3:[]
    }
  },
  components: {navFooter},
  // mounted() {
  //   Bus.$on("msg", data => {
  //     this.homeData3 = data
  //     console.log(this.homeData3)
  //   }) 
  // }
}
</script>

<style scoped>
  .main-content-container {
    height: 100%;
    width: 100%;
  }
  .type_member_container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .member_menu {
    width: 175px;
  }
  .member_content {
    width: calc(100% - 175px);
  }
</style>


// WEBPACK FOOTER //
// src/components/layout/mainContent.vue